import React from "react"
import Image from "next/image"
import { DefaultAvatar } from "../../libs/vars/url"

function HeaderSelectTop({ children }) {
  return (
    <React.Fragment>
      <div className="border-b border-gray-200 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 justify-between">
            <div className="flex">
              <div className="flex flex-shrink-0 items-center">{children}</div>
            </div>

            <div className="ml-6 flex items-center">
              <Image
                src={DefaultAvatar}
                className="h-8 w-8 rounded-full"
                alt="Avatar"
                width={32}
                height={32}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default HeaderSelectTop
